'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _iconFactory = require('./utils/iconFactory');

var _iconFactory2 = _interopRequireDefault(_iconFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookIcon = (0, _iconFactory2.default)('facebook', {
  icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
  mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
  color: '#3b5998'
});

exports.default = FacebookIcon;


//////////////////
// WEBPACK FOOTER
// ./~/react-share/lib/FacebookIcon.js
// module id = 346
// module chunks = 95715928098905 172441821870073 232727283551173